import { Pipe, PipeTransform } from '@angular/core';
import { ContentService } from '../../services/content/content.service';
import { Models } from '@ibexfusion/models';
import * as _ from 'lodash';
import { HelperService } from '../../services/helper/helper.service';

@Pipe({
  name: 'accommodation'
})

export class AccommodationPipe implements PipeTransform {

  //Hello World
  constructor(
    private contentService: ContentService
  ) {
  }

  private static enhanceAccommodationDetail(accommodationContent, data) {
    accommodationContent.teaser = data.introduction || data.description;
    accommodationContent.description = data.description;
    accommodationContent.website = data.website;
    accommodationContent.seasonTimes = data.seasonTimes;
    if (data.location) {
      accommodationContent.street = data.location.address;
      accommodationContent.city = data.location.city;
      accommodationContent.zip = data.location.zip;
      if (data.location.coordinates) {
        accommodationContent.latitude = data.location.coordinates.latitude;
        accommodationContent.longitude = data.location.coordinates.longitude;
      }
    }
    if (data.contact && data.contact.length) {
      for (const contactVariant of data.contact[0].variants) {
        if (contactVariant.type === 'phone') {
          accommodationContent.phone = contactVariant.value;
        }
        if (contactVariant.type === 'fax') {
          accommodationContent.fax = contactVariant.value;
        }
        if (contactVariant.type === 'email') {
          accommodationContent.email = contactVariant.value;
        }
      }
    }
    if (data.raw) {
      const raw = JSON.parse(data.raw);
      accommodationContent.isSuperior = raw.isClassificationSuperior;
      if (typeof accommodationContent.isSuperior === 'string' && !isNaN(parseInt(accommodationContent.isSuperior))) {
        accommodationContent.isSuperior = parseInt(accommodationContent.isSuperior) > 0;
      }
      let fields = ['barrierFreeRoomCount', 'bedCount', 'classificationId', 'doubleRoomCount', 'roomCount', 'singleRoomCount'];
      for (let field of fields) {
        accommodationContent[field] = raw[field];
      }
      accommodationContent.banquetParticipantsMax = raw.banquetParticipantMax;
      accommodationContent.banquetParticipantsMin = raw.banquetParticipantMin;
      accommodationContent.suiteCount = raw.suiteCounte;
      accommodationContent.seminarParticipantsMin = raw.seminarParticipantMin;
      accommodationContent.seminarParticipantsMax = raw.seminarParticipantMax;
      accommodationContent.isGarni = raw.isClassificationGarni;
    }
    accommodationContent.openingHours = HelperService.initOpeningData(data) || accommodationContent.openingHours;
    if (!!data?.openingHours?.disabled) {
      delete accommodationContent.openingHours;
    }
    return accommodationContent;
  }

  transform(entry: Models.ContentEntry): any {
    if (!entry || (!entry.files && !entry.title && (!entry.detail || Object.keys(entry.detail).length === 0))) {
      return null;
    }

    if (!this.contentService.isValid(entry)) {
      return null;
    }

    const accommodationEntry: any = new Models.AccommodationEntry();

    if (entry.related && entry.related.entries && entry.related.entries.length > 0) {
      const entries: Models.AccommodationEntry[] = [];

      for (const item of entry.related.entries) {
        const contentEntry = this.contentService.getEntry(item.id);
        const transformed = this.transform(contentEntry);
        if (transformed) {
          entries.push(transformed);
        }
      }
      return entries.length === 0 ? null : entries;
    }
    let media = this.contentService.getMediaEntriesForEntry(entry.getId());

    media = _.orderBy(media, ['type'], ['asc']);

    let accommodationContent = { sourceId: entry._id, title: entry.title, media };

    if (entry.detail) {
      accommodationContent = AccommodationPipe.enhanceAccommodationDetail(accommodationContent, entry.detail);
    }
    accommodationEntry.populateFromJSON(accommodationContent);
    return accommodationEntry;
  }
}
